import { put, takeLatest, select, all, take } from 'redux-saga/effects'

import { SessionNamingConventionType } from '@tabeeb/enums'
import { getHasShareContentPermission } from '@tabeeb/modules/contentSharings/selectors'
import { getContentId } from '@tabeeb/modules/shared/content/selectors'
import {
  closeTenantFormsDialog,
  openTenantFormsDialog,
  submitTenantFormAnswers,
} from '@tabeeb/modules/tenantForms/actions'
import { getSessionPermissionsSuccess } from '@tabeeb/modules/permissions/actions'
import { getTenantsListForReview } from '../selectors'
import * as rawActions from '../actions'

function* onGetSessionPermissionsSuccess(action) {
  const hasShareContentPermission = yield select(getHasShareContentPermission)
  if (!hasShareContentPermission) return

  const contentId = yield select(getContentId)
  yield put(rawActions.getTenantsListForReviewRequest(contentId))
  yield put(rawActions.getContentDescriptionsRequest(contentId))
}

function* renameContentForTenant(action) {
  const tenantId = action.payload

  const tenantsListWithNamingConventionInfo = yield select(getTenantsListForReview)
  const contentId = yield select(getContentId)

  const reviewerTenant = tenantsListWithNamingConventionInfo.find((t) => t.Id === tenantId)

  yield put(
    openTenantFormsDialog({
      sncType: SessionNamingConventionType.RenameSession,
      subdomain: reviewerTenant?.Subdomain,
    })
  )

  const resultAction = yield take([submitTenantFormAnswers, closeTenantFormsDialog])
  if (resultAction.type === closeTenantFormsDialog().type) {
    return
  }

  const {
    payload: { description = null, contentNameParts = null },
  } = resultAction

  yield put(closeTenantFormsDialog())

  const data = {
    contentId,
    tenantId,
    description,
    contentNameParts,
  }

  yield put(rawActions.renameContentForTenantRequest(data))
}

function* contentDescription() {
  yield all([
    takeLatest(getSessionPermissionsSuccess, onGetSessionPermissionsSuccess),
    takeLatest(rawActions.renameContentForTenant, renameContentForTenant),
  ])
}

export default contentDescription
